import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-6 bg-[#14142B] text-[#F5F0E8]" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-184">
            No es que tu hijo sea "difícil".
          </h2>
          <p className="text-xl text-[#F5F0E8]/80 max-w-2xl mx-auto" data-id="element-185">
            Es que la noche se volvió un sistema que se autoalimenta.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-187">
            <div className="bg-[#1C1C2E] p-6 rounded-xl border border-[#D4A574]/10 shadow-lg" data-id="element-188">
              <h3 className="text-lg font-semibold text-[#D4A574] mb-3 flex items-center gap-2" data-id="element-189">
                <Clock className="w-5 h-5" data-id="element-190" />
                El ciclo infinito
              </h3>
              <p className="text-[#F5F0E8]/80" data-id="element-191">
                En algún punto, con la mejor intención, empezaste a estirar: un
                cuento más, un ratito más, una excepción más.
              </p>
            </div>

            <div className="bg-[#1C1C2E] p-6 rounded-xl border border-[#D4A574]/10 shadow-lg" data-id="element-192">
              <h3 className="text-lg font-semibold text-[#D4A574] mb-3 flex items-center gap-2" data-id="element-193">
                <AlertCircle className="w-5 h-5" data-id="element-194" />
                La lógica infantil
              </h3>
              <p className="text-[#F5F0E8]/80" data-id="element-195">
                Sin querer, el cerebro de tu hijo aprendió algo muy lógico:{' '}
                <span className="italic text-white" data-id="element-196">
                  "Si insisto, la noche se estira."
                </span>{' '}
                Eso no es maldad. Es aprendizaje.
              </p>
            </div>

            <div className="bg-[#1C1C2E] p-6 rounded-xl border border-[#D4A574]/10 shadow-lg" data-id="element-197">
              <h3 className="text-lg font-semibold text-[#D4A574] mb-3 flex items-center gap-2" data-id="element-198">
                <BatteryWarning className="w-5 h-5" data-id="element-199" />
                El costo real
              </h3>
              <p className="text-[#F5F0E8]/80" data-id="element-200">
                El problema no es solo el sueño. Es lo que pasa en vos cuando se
                repite por décima vez. La culpa, la bronca y el agotamiento.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative" data-id="element-201">
            <div className="absolute inset-0 bg-[#D4A574] blur-[100px] opacity-10 rounded-full" data-id="element-202" />
            <div className="relative bg-[#1C1C2E]/50 backdrop-blur-sm p-8 rounded-2xl border border-[#D4A574]/20" data-id="element-203">
              <h3 className="text-2xl font-serif mb-6 text-white" data-id="element-204">
                La trampa de la negociación
              </h3>
              <ul className="space-y-4" data-id="element-205">
                {['Un cuento más para que se calme', "Un ratito más al lado para que 'por fin se duerma'", 'Una excepción más para terminar la pelea', 'Agua, pipí, miedo, otra vez agua...'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#F5F0E8]/90" data-id="element-206">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#D4A574] flex-shrink-0" data-id="element-207" />
                    {item}
                  </li>)}
              </ul>
              <div className="mt-8 pt-8 border-t border-[#F5F0E8]/10 text-center" data-id="element-208">
                <p className="text-lg font-serif italic text-[#D4A574]" data-id="element-209">
                  "No necesitás más paciencia. Necesitás un sistema."
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}